import {
  FETCH_FEATURE_FAILURE,
  FETCH_FEATURE_LOADING,
  FETCH_FEATURE_SUCCESS,
  FETCH_LEAVE_TYPES_SUCCESS,
  FETCH_LEAVE_TYPES_FAILURE,
  FETCH_HOLIDAYS_SUCCESS,
  FETCH_HOLIDAYS_LOADING,
  FETCH_HOLIDAYS_FAILURE,
  ADD_SETTING_SUCCESS,
  ADD_SETTING_LOADING,
  ADD_SETTING_FAILURE,
  DELETE_SETTING_FAILURE,
  DELETE_SETTING_SUCCESS,
  DELETE_SETTING_LOADING,

} from '../Types/featureTypes';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const fetchFeatures = () => {
  return dispatch => {
    dispatch({
      type: FETCH_FEATURE_LOADING
    });
    api
      .get(`${API_WP}Setting/getSettingsName/features`)
      .then((response: any) => {
        const { data } = response.data;
        dispatch({
          type: FETCH_FEATURE_SUCCESS,
          payload: data[0]?.Web
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_FEATURE_FAILURE,
          payload: errorMsg
        });
      });
  };
};
export const fetchFeaturesLeave = () => {
  return dispatch => {
    dispatch({
      type: FETCH_FEATURE_LOADING
    });
    api
      .get(`${API_WP}Setting/getSettingsName/Leave`)
      .then((response: any) => {
        const { data } = response.data;
        dispatch({
          type: FETCH_LEAVE_TYPES_SUCCESS,
          payload: data || []
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_LEAVE_TYPES_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const fetchHolidays = () => {
  return dispatch => {
    dispatch({
      type: FETCH_HOLIDAYS_LOADING
    });
    api
      .get(`${API_WP}Setting/getSettingsName/Holidays`)
      .then((response) => {        
        const { data } = response.data;
        if (data && data.length > 0) {
          data.forEach((holiday, index) => {
            console.log(`Holiday ${index} dates:`, {
              id: holiday._id,
              label: holiday.label,
              date_debut: holiday.date_debut,
              date_fin: holiday.date_fin
            });
          });
        }
        
        dispatch({
          type: FETCH_HOLIDAYS_SUCCESS,
          payload: data || []
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        console.error('Error fetching holidays:', error);
        dispatch({
          type: FETCH_HOLIDAYS_FAILURE,
          payload: errorMsg
        });
      });
  };
};
export const addSetting = (settingData, settingType) => {
  return dispatch => {
    dispatch({
      type: ADD_SETTING_LOADING
    });
    
    api.post(`${API_WP}Setting/addSetting`, {
      ...settingData,
      name: settingType 
    })
      .then((response) => {
        const { data } = response;
        dispatch({
          type: ADD_SETTING_SUCCESS,
          payload: data
        });
        
        switch(settingType) {
          case 'Holidays':
            dispatch(fetchHolidays());
            break;
          case 'Leave':
            dispatch(fetchFeaturesLeave());
            break;
          default:
            break;
        }
      })
      .catch(error => {
        const errorMsg = error.message;
        console.error(`Error adding ${settingType}:`, error);
        dispatch({
          type: ADD_SETTING_FAILURE,
          payload: errorMsg
        });
      });
  };
};

export const deleteSetting = (id, settingType) => {
  return dispatch => {
    dispatch({
      type: DELETE_SETTING_LOADING
    });
    
    api.delete(`${API_WP}Setting/deleteSetting/${id}`)
      .then((response) => {
        dispatch({
          type: DELETE_SETTING_SUCCESS,
          payload: id
        });
        
        switch(settingType) {
          case 'Holidays':
            dispatch(fetchHolidays());
            break;
          case 'Leave':
            dispatch(fetchFeaturesLeave());
            break;
          default:
            break;
        }
      })
      .catch(error => {
        const errorMsg = error.message;
        console.error(`Error deleting ${settingType}:`, error);
        dispatch({
          type: DELETE_SETTING_FAILURE,
          payload: errorMsg
        });
      });
  };
};